import React, { useCallback } from "react";

import { Namespace, useTranslate } from "localization";
import { BigAlert } from "ui/core";

import config from "../config";

import { AnalyticsEvent, useAnalytics } from "../Tracking";

export interface ErrorAlertProps {
  showReload?: boolean;
}

const ErrorAlert: React.FC<ErrorAlertProps> = ({ showReload = true }) => {
  const { translate } = useTranslate(Namespace.ERROR);

  const { trackEvent } = useAnalytics();
  const handleRefresh = useCallback(() => {
    window.location.reload();
  }, []);

  const handleContactSupport = () => {
    trackEvent(AnalyticsEvent.HOMEPAGE_ACTION, {
      name: "Action",
      label: "Support",
    });
    window.location.assign(`mailto:${config.supportEmail}`);
  };

  return (
    <BigAlert
      variant="error"
      primaryAction={
        showReload
          ? {
              label: translate("retry"),
              onClick: handleRefresh,
            }
          : void 0
      }
      secondaryAction={{
        label: translate("contactSupport"),
        onClick: handleContactSupport,
      }}
      title={translate("loadingErrorTitle")}
    >
      {translate("loadingErrorText")}
    </BigAlert>
  );
};

export default ErrorAlert;
